import {
  CategoryDisplayName,
  getCategoryByName,
} from '@oxappsec/ox-consolidated-categories';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { FilterTypeToFilter } from '../../common/filters-utils/filters-utils';
import DashboardIssuesPanel from '../components/DashboardIssuesPanel/DashboardIssuesPanel';
import Panel from '../../elements/Panel/Panel';
import { handleFilterBy } from '../../issues/top-issues/actions/top-issues-actions';
import { useTopIssues } from '../../issues/top-issues/api/top-issues-api';
import ScanStore from '../../new-scan/store/scan-store';
import { createTopIssuesCategories } from '../utils/top-issues-utils';

const DashboardIssuesPanelContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { topIssues, topIssuesCategory, categoriesFilters, loadingIssues } =
    useTopIssues();
  const { isScanning } = useSnapshot(ScanStore);

  const handleChangeTopIssues = (categoryName: string) => {
    if (categoryName) {
      const category = getCategoryByName(categoryName as CategoryDisplayName);
      if (category) {
        handleFilterBy(FilterTypeToFilter.Category, category?.id);
      }
    } else {
      handleFilterBy();
    }
  };

  const categories = createTopIssuesCategories(categoriesFilters);

  const isLoading =
    loadingIssues.isPending() || (!topIssues?.length && isScanning);
  const message = loadingIssues.isPending()
    ? 'Loading issues...'
    : 'Scanning...';
  return (
    <Panel height={'100%'} p={2}>
      <DashboardIssuesPanel
        loadingMessage={message}
        topIssues={topIssues}
        handleChangeTopIssues={handleChangeTopIssues}
        topIssuesCategory={topIssuesCategory}
        categories={categories}
        loadingIssues={isLoading}
      />
    </Panel>
  );
};

export default DashboardIssuesPanelContainer;
